import {
    useParams,
    useLocation,
    useHistory,
    useRouteMatch,
} from "react-router-dom"
import { useEffect, useState } from "react"
export default function AddPA(props) {
    useEffect(() => {
        window.open(`https://geojson.io/#map=7.42/33.032/-7.105`);

    }, [])
    const params = useParams();
    const id = params.id
    console.log("PARAMS ", params)
    const [quartierName, setQuartierName] = useState("")
    const [polygones, setPolygone] = useState("")
    const [detectedPolygones, setDetectedPolygones] = useState({
        "type": "FeatureCollection",
        "features": []
    })
    const [validating, setValidating] = useState(false)
    const [validatingQuartier, setValidatingQuartier] = useState(false)
    const [error, setError] = useState("")
    const [quartierToValidate, setQuartierToValidate] = useState(0)
    const [validatingRecoupement, setValidatingRecoupement] = useState(false)
    const [validatingRGC, setValidatingRGC] = useState(false)
    const [validatingAdding, setValidatingAdding] = useState(false)
    const [validatingMAJ, setValidatingMAJ] = useState(false)

    const validateRecoupement = (item) => {
        return (new Promise((resolve, reject) => {
            setValidatingRecoupement(true)
            resolve(true)
        }))

    }

    const validateRGC = (item) => {
        return (new Promise((resolve, reject) => {
            setValidatingRGC(true)
            resolve(true)
        }))

    }
    const validateAdding = (item) => {
        return (new Promise((resolve, reject) => {
            setValidatingAdding(true)
            resolve(true)
        }))

    }
    const validateMAJ = (item) => {
        return (new Promise((resolve, reject) => {
            setValidatingMAJ(true)
            resolve(true)
        }))

    }
    const validatePolygones = () => {
        console.log("VALIDATING 1")
        setValidating(true)
        try {
            console.log(polygones)
            console.log(JSON.parse(polygones))
            setDetectedPolygones(JSON.parse(polygones))
            setValidating(false)
            setError("")

        }
        catch (e) {
            console.log(e)
            setError(e)
            setValidating(false)
        }
    }

    const valdateQuartierName = (item) => {
        console.log("VALIDATING 2", item)
        setValidatingQuartier(true)
        let recoupement_done = false
        let rgc_done = false
        let adding_done = false
        let maj_done = false
        validateRecoupement().then(() => {
            recoupement_done = true
            if (recoupement_done && rgc_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }
        }).catch(err => {
            recoupement_done = true
            if (recoupement_done && rgc_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }
            console.log(err)
        })
        validateRGC().then(() => {

            rgc_done = true
            if (recoupement_done && rgc_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }

        }).catch(err => {
            rgc_done = true
            if (recoupement_done && rgc_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }
            console.log(err)
        })
        validateAdding().then(() => {
            adding_done = true
            if (recoupement_done && adding_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }
        }).catch(err => {
            rgc_done = true
            if (recoupement_done && rgc_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }
            console.log(err)
        })
        validateMAJ().then(() => {
            maj_done = true
            if (recoupement_done && rgc_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }
        }).catch(err => {
            maj_done = true
            if (recoupement_done && rgc_done && adding_done && maj_done) {
                setQuartierToValidate(quartierToValidate + 1)
            }
            console.log(err)
        })



    }
    return (
        <div className={"replace_pa_container"}>
            <div className={"replace_pa_inner"}>
                {/* <div className={"input_container"}>
                <label htmlFor="name" className={"quartier_name_label"}>Nom du nouveau quartier </label>
                <input id="name" className={"quartier_name"} type="text" value={quartierName} onChange={(e)=>{
                    setQuartierName(e.target.value)
                }} />
                </div> */}
                <div className={"input_container"}>
                    <label htmlFor="napolygonesme" className={"quartier_label"}>Copiez/collez les nouveaux polygones </label>
                    <textarea id="polygones" className={"quartier_name"} type="text" value={polygones} onChange={(e) => {
                        console.log("E ", e)
                        setPolygone(e.target.value)
                    }} />
                    {error ? (
                        <p className="error">Vérifier le format : {error.toString()} </p>
                    ) : null}
                </div>

                <div className={"input_container"}>
                    {validating ? (
                        <button className={"validate_polygones"}><i className="fas fa-circle-notch fa-spin"></i></button>


                    ) : (
                        <button onClick={() => {
                            validatePolygones()
                        }}
                            className={"validate_polygones"}>Valider</button>
                    )}

                </div>
                <div className={"input_container"}>
                    <p className={"detected_polygones"}>{detectedPolygones.features.length} polygone(s) détecté(s)</p>
                    {detectedPolygones.features.map((item, key) => {
                        return (
                            <div key={key} className={"input_container"}>
                                <div className={"input_container"}>
                                    <p className={"quartier_number"} >Quartier n° {key + 1}</p>
                                    <label htmlFor="name" className={"quartier_name_label"}>Nom du nouveau quartier </label>
                                    <input disabled={quartierToValidate < key} id="name" className={"quartier_name"} type="text" value={quartierName} onChange={(e) => {
                                        setQuartierName(e.target.value)
                                    }} />
                                    <a className={"quartier_check"} href={
                                        `http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify({
                                            "type": "Feature",
                                            "properties": {},
                                            "geometry": item.geometry
                                        }))}`
                                    } target="__blank" >Voir le quartier</a>

                                    {validatingQuartier ? (
                                        <button className={"validate_polygones"}><i className="fas fa-circle-notch fa-spin"></i></button>
                                    ) : (
                                        <button className={"validate_polygones"} onClick={() => { valdateQuartierName() }}>Valider</button>
                                    )}
                                    {validatingQuartier && quartierToValidate == key ? (
                                        <div className={"input_container"}>
                                            <div className={"validation__container"}>
                                                <p className={"validation_title"}>Vérification du recoupement <i className="fas fa-circle-notch fa-spin"></i></p>
                                            </div>
                                            <div className={"validation__container"}>
                                                <p className={"validation_title"}>Vérification de la commune region province ...<i className="fas fa-circle-notch fa-spin"></i> </p>
                                            </div>
                                            <div className={"validation__container"}>
                                                <p className={"validation_title"}>Ajout du nouveau quartier<i className="fas fa-circle-notch fa-spin"></i> </p>
                                            </div>
                                            <div className={"validation__container"}>
                                                <p className={"validation_title"}>Mise à jour des bases de données<i className="fas fa-circle-notch fa-spin"></i> </p>
                                            </div>
                                        </div>) : null}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div >
    )

}